<template>
  <div class="bg-nav">
  	<div class="nav">
      <a class="on-class" @click="defaultNav('Home')"><img class="logo" src="./../assets/logo.png"></a>
  		<ul class="menu">
  			<li :class="homeNav" @click="defaultNav('Home')">彩票大厅</li>
  			<li ref="menuchar" :class="{ 'select-on': this.$store.state.menuchar }" @click="defaultNav('LottoDetail','graphs')">走势图</li>
  			<li :class="longQueueNav" @click="defaultNav('LongQueue')">长龙统计</li>
  			<li :class="newsNav" @click="defaultNav('News')">资讯新闻</li>
  			<li @click="See()">香港彩</li>
  		</ul>
  	</div>
  </div>
</template>
<script>
  import global_config  from '@/components/Global'
  export default {
    data() {
      return {
        homeNav: '',
        runchartNav: '',
        newsNav: '',
        longQueueNav: ''
      }
    },
    mounted: function() {
      this.setNav(this.$route.name,'select-on',this.$route.params.showFlag);
    },
    methods: {
      See() {
        window.open('/sixmark')
      },
      defaultNav(id,showFlag) {
        this.$router.push({name:id,path:'/'+id,params:{showFlag:showFlag}});
        this.$nextTick(function () {
          this.setNav(this.$route.name,'select-on',showFlag);
        })
      },
      setNav(id,css,type) {
        if(id == 'Home') {
          this.homeNav = css;
          this.runchartNav = '';
          this.newsNav = '';
          this.longQueueNav = '';
          this.$store.commit('charhide')
        }else if(id == 'LottoDetail') {
          this.homeNav = '';
          this.runchartNav = css;
          this.newsNav = '';
          this.longQueueNav = '';
          if(type == 'graphs'){
            this.$store.commit('charshow')
          }
        }else if(id == 'News') {
          this.homeNav = '';
          this.runchartNav = '';
          this.newsNav = css;
          this.longQueueNav = '';
          this.$store.commit('charhide')
        }else if(id == 'LongQueue') {
          this.homeNav = '';
          this.runchartNav = '';
          this.newsNav = '';
          this.longQueueNav = css;
          this.$store.commit('charhide')
        }else{
          this.homeNav = css;
          this.runchartNav = '';
          this.newsNav = '';
          this.longQueueNav = '';
          this.$store.commit('charhide')
        }
      }
    },
    watch:{
      $route(to){
        //更改底部默认样式
        this.setNav(to.name, 'select-on');
      }
    },

  }
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .bg-nav {
    width: 100%;
    height: 60px;
    background-color: #ffffff;
    opacity: 0.95;
    position: relative;
  }
  @media screen and (max-width: 1281px){
    .nav {
      width: 1024px;
    }
  }
  @media screen and (min-width: 1281px){
    .nav {
      width: 1280px;
    }
  } 
  .nav {
    height: 60px;
    margin: 0 auto;
    overflow: hidden;
  }
  .logo {
    height: 60px;
    float: left;
    margin-left: 16px;
  }
  .menu {
    height: 60px;
    line-height: 60px;
    float: right;
    width: 75%;
  }
  .menu > img,ul {
    display: inline-block;
    height: 60px;
  }
  .menu > li {
    display: inline-block;
    height: 60px;
    width: 19.3%;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 60px;
    letter-spacing: 0px;
    color: #fb4c37;
    text-align: center;
    cursor: pointer;
  }
  .select-on {
    background-color: #f0f0f0;
    color: #fe8c00 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue